import {
  Button,
  Card,
  Divider,
  Grid,
  MenuItem,
  Snackbar,
  Typography,
  IconButton,
  Alert as MuiAlert,
  Pagination,
  CardContent,
  Box,
  TextField,
  Avatar
} from '@mui/material'
import { Add as AddIcon, Delete } from '@mui/icons-material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import CreateWaiterDialog from './waiter/createWaiterDialog'
import MainCard, {
  ConfirmationDialog,
  SnackBarHideDuration,
  SnackBarTransition,
  ShowNoRecordsFound,
  stringAvatar,
  ErrorScreen
} from '../../utils/ui_utils'
import UserTypeShimmer from '../../utils/ui_components/shimmers/userTypeShimmer'
import {
  useCreateWaiter,
  useFetchWaiters,
  useUpdateWaiter
} from '../../modules/waiters/waiterHooks'
import { useFetchOutlet } from '../../modules/outlet/outletHooks'

function Waiter() {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(12)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const [selectedOutlet, setSelectedOutlet] = useState('')
  const [selectedWaiter, setSelectedWaiter] = useState({})
  const [deleteConfirmationVisibility, setDeleteConfirmationVisibility] =
    useState(false)
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const { outletFetch, outletFetchData, outletFetchError, outletFetchLoading } =
    useFetchOutlet()
  const {
    fetchWaiters,
    fetchWaitersData,
    fetchWaitersError,
    fetchWaitersLoading
  } = useFetchWaiters()
  const { createWaiter } = useCreateWaiter()
  const { updateWaiter } = useUpdateWaiter()
  const [waiterDialogVisible, setWaiterDialogVisible] = useState(false)
  const [waiterDialogMode, setWaiterDialogMode] = useState('edit')
  const [selectedOutletName, setSelectedOutletName] = useState('')
  const [outlets, setOutlets] = useState([])
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const handlePageChange = async (event, value) => {
    setPage(value)
    if (
      selectedOutlet != null &&
      selectedOutlet != undefined &&
      selectedOutlet != ''
    ) {
      let payload = {
        outlet_id: selectedOutlet,
        pageNumber: value,
        limit: limit
      }
      fetchWaiters(payload)
    }
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNum = parseInt(goToPageInput, 10)
    if (pageNum >= 1 && pageNum <= pagecount) {
      handlePageChange(null, pageNum)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  const history = useNavigate()

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  useEffect(() => {
    businessCheck(history)
    let payload = {
      pageNumber: page,
      limit: limit
    }
    outletFetch(payload)
  }, [])

  useEffect(() => {
    if (fetchWaitersData.data?.length > 0) {
      pageCount(fetchWaitersData.total)
    }
  }, [fetchWaitersData])

  useEffect(() => {
    if (outletFetchData.data?.length > 0) {
      setOutlets(outletFetchData.data)
      setSelectedOutlet(outletFetchData.data[0]._id)
      setSelectedOutletName(outletFetchData.data[0].name)
      let payload = {
        outlet_id: outletFetchData.data[0]._id,
        pageNumber: page,
        limit: limit
      }
      fetchWaiters(payload)
    } else {
      setOutlets([])
      setSelectedOutlet('')
      setSelectedOutletName('')
    }
  }, [outletFetchData])

  const handleOutletChange = (event) => {
    setSelectedOutlet(event.target.value)
    outlets.map((outlet) => {
      if (outlet._id == event.target.value) {
        setSelectedOutletName(outlet.name)
        return
      }
    })
    fetchWaiterOnError(event.target.value)
  }

  const fetchOutletOnError = () => {
    let payload = {
      pageNumber: page,
      limit: limit
    }
    outletFetch(payload)
  }

  const fetchWaiterOnError = (outlet_id) => {
    let payload = {
      outlet_id: outlet_id,
      pageNumber: page,
      limit: limit
    }
    fetchWaiters(payload)
  }

  const WaitersListUI = ({ waiter, index }) => (
    <MainCard
      sx={{
        mt: 1,
        p: 2,
        alignItems: 'center',
        transition: 'box-shadow 0.3s ease',
        borderRadius: 1,
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
          backgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }}
    >
      <Grid container column={6} spacing={1}>
        <Grid item>
          <Avatar {...stringAvatar(waiter?.name)} />
        </Grid>
        <Grid item xs md>
          <Grid
            container
            direction={'column'}
            sx={{ pl: 1, cursor: 'pointer' }}
            onClick={() => {
              setWaiterDialogVisible(true)
              setWaiterDialogMode('edit')
              setSelectedWaiter(waiter)
            }}
          >
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              {waiter?.name}
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Commission {waiter?.commission}%
            </Typography>
          </Grid>
        </Grid>
        <Grid item textAlign="right">
          <IconButton
            size="small"
            color="lightRed"
            component="span"
            onClick={() => {
              setSelectedWaiter(waiter)
              setDeleteConfirmationVisibility(true)
            }}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </MainCard>
  )

  return (
    <>
      <Helmet title="Waiters" />
      <Grid
        container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Waiters
          </Typography>
        </Grid>
        {!outletFetchError && (
          <Grid item justifyContent="space-between">
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              color="primary"
              size="small"
              onClick={() => {
                if (
                  selectedOutlet != null &&
                  selectedOutlet != undefined &&
                  selectedOutlet != ''
                ) {
                  setWaiterDialogVisible(true)
                  setWaiterDialogMode('new')
                  setSelectedWaiter({
                    name: '',
                    commission: '',
                    outlet_id: ''
                  })
                } else {
                  toastMessage('Select Outlet', 'warning')
                }
              }}
            >
              Create Waiter
            </Button>
          </Grid>
        )}
      </Grid>
      <Divider sx={{ paddingTop: 5 }} />
      {outletFetchError ? (
        <ErrorScreen
          onClick={() => {
            fetchOutletOnError()
          }}
        />
      ) : (
        <div>
          <Grid container spacing={6} style={{ paddingTop: 10 }}>
            <Grid item md={3}>
              <TextField
                size="small"
                label="Outlet"
                id="outlet"
                name="outlet"
                variant="outlined"
                margin="dense"
                value={selectedOutlet}
                onChange={handleOutletChange}
                select
                fullWidth
              >
                {outlets.map((outlet) => (
                  <MenuItem key={outlet._id} value={outlet._id}>
                    {outlet.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <div>
            {fetchWaitersError ? (
              <ErrorScreen
                onClick={() => {
                  fetchWaiterOnError(selectedOutlet)
                }}
              />
            ) : (
              <div>
                {fetchWaitersLoading && <UserTypeShimmer />}

                {!fetchWaitersLoading &&
                  fetchWaitersData.data &&
                  fetchWaitersData.data?.length <= 0 && <ShowNoRecordsFound />}

                {!fetchWaitersError &&
                  !fetchWaitersLoading &&
                  fetchWaitersData.data &&
                  fetchWaitersData.data?.length > 0 && (
                    <Grid container spacing={5} sx={{ paddingTop: 5 }}>
                      <Grid item xs sm md>
                        <Box sx={{ margin: 2 }}>
                          <Card raised sx={{ borderRadius: 3 }}>
                            <CardContent>
                              <Grid
                                container
                                columns={6}
                                rowSpacing={3}
                                columnSpacing={3}
                              >
                                {fetchWaitersData.data?.map((waiter, index) => (
                                  <Grid item xs={6} sm={3} md={2} key={index}>
                                    <WaitersListUI waiter={waiter} />
                                  </Grid>
                                ))}
                              </Grid>
                            </CardContent>
                            {pagecount > 1 && (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: 2,
                                  p: 2,
                                  backgroundColor: 'grey.50',
                                  borderRadius: 1
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%'
                                  }}
                                >
                                  <Pagination
                                    count={pagecount}
                                    page={page}
                                    color="secondary"
                                    size="small"
                                    boundaryCount={2}
                                    siblingCount={0}
                                    showFirstButton
                                    showLastButton
                                    onChange={handlePageChange}
                                    sx={{
                                      '& .MuiPaginationItem-root': {
                                        transition: 'all 0.2s ease-in-out'
                                      }
                                    }}
                                  />
                                </Box>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    backgroundColor: 'white',
                                    p: 2,
                                    borderRadius: 1,
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                                    transition: 'box-shadow 0.2s ease-in-out',
                                    '&:hover': {
                                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                                    }
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: 'text.secondary',
                                      fontWeight: 500
                                    }}
                                  >
                                    Jump to
                                  </Typography>
                                  <TextField
                                    size="small"
                                    value={goToPageInput}
                                    onChange={handleGoToPageChange}
                                    onKeyPress={handleGoToPageKeyPress}
                                    placeholder="Page"
                                    sx={{
                                      width: '80px',
                                      '& .MuiOutlinedInput-root': {
                                        backgroundColor: 'white',
                                        transition: 'all 0.2s ease-in-out',
                                        '& fieldset': {
                                          borderColor: 'grey.300',
                                          borderWidth: '1px'
                                        },
                                        '&:hover fieldset': {
                                          borderColor: 'secondary.main',
                                          borderWidth: '1.5px'
                                        },
                                        '&.Mui-focused fieldset': {
                                          borderColor: 'secondary.main',
                                          borderWidth: '2px',
                                          boxShadow:
                                            '0 0 0 3px rgba(156, 39, 176, 0.1)'
                                        }
                                      },
                                      '& .MuiOutlinedInput-input': {
                                        textAlign: 'center',
                                        fontWeight: 500,
                                        padding: '7px 8px',
                                        height: '20px',
                                        lineHeight: '20px'
                                      }
                                    }}
                                  />
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: 'text.secondary',
                                      fontWeight: 400
                                    }}
                                  >
                                    of {pagecount}
                                  </Typography>
                                  <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={handleGoToPageSubmit}
                                    disabled={
                                      !goToPageInput ||
                                      parseInt(goToPageInput, 10) < 1 ||
                                      parseInt(goToPageInput, 10) > pagecount
                                    }
                                    sx={{
                                      textTransform: 'none',
                                      fontWeight: 500,
                                      px: 2,
                                      py: 0.75,
                                      height: '34px',
                                      lineHeight: 1,
                                      transition: 'all 0.2s ease-in-out',
                                      '&:hover': {
                                        transform: 'translateY(-1px)',
                                        boxShadow:
                                          '0 4px 8px rgba(156, 39, 176, 0.3)'
                                      },
                                      '&:active': {
                                        transform: 'translateY(0)'
                                      }
                                    }}
                                  >
                                    Go
                                  </Button>
                                </Box>
                              </Box>
                            )}
                          </Card>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
              </div>
            )}
          </div>
        </div>
      )}

      <CreateWaiterDialog
        outlet={selectedOutletName}
        visible={waiterDialogVisible}
        outlets={outletFetchData.data}
        initialValue={selectedWaiter}
        title={
          waiterDialogMode == 'new' ? 'Create New Waiter' : 'Edit Waiter Info'
        }
        okText={waiterDialogMode == 'new' ? 'Create' : 'Update'}
        action={waiterDialogMode}
        onClose={() => setWaiterDialogVisible(false)}
        onSubmit={async (data) => {
          let _data = _.cloneDeep(data)
          _data.commission = +_data.commission
          _data.name = _data.name.trim()
          if (waiterDialogMode == 'new') {
            _data.outlet_id = selectedOutlet
            await createWaiter(_data, (sucess, error, data) => {
              if (error) {
                toastMessage(data, 'error')
              } else {
                toastMessage(data, 'success')
                if (selectedOutlet !== undefined && selectedOutlet !== '') {
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  fetchWaiters(payload)
                }
                setWaiterDialogVisible(false)
              }
            })
          } else {
            if (!_data.commission) {
              _data.commission = 0
            }
            _data.id = _data._id
            delete _data._id
            delete _data.business_id
            delete _data.key
            updateWaiter(_data, (success, error, res) => {
              if (error) {
                toastMessage(res, 'error')
              } else {
                toastMessage(res, 'success')
                if (selectedOutlet !== undefined && selectedOutlet !== '') {
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  fetchWaiters(payload)
                }
                setWaiterDialogVisible(false)
              }
            })
          }
        }}
      />
      <ConfirmationDialog
        visibility={deleteConfirmationVisibility}
        title={'Delete Waiter'}
        message={`Do you want to delete Waiter - ${selectedWaiter?.name} ?`}
        okText="Delete"
        cancelText={'Cancel'}
        onCancel={() => {
          setDeleteConfirmationVisibility(false)
        }}
        onOk={() => {
          let _data = _.cloneDeep(selectedWaiter)
          _data.id = _data._id
          delete _data._id
          delete _data.business_id
          _data.delete_status = true
          delete _data.key
          updateWaiter(_data, (success, error, res) => {
            if (error) {
              setDeleteConfirmationVisibility(false)
              toastMessage('Waiter delete failed', 'error')
            } else {
              toastMessage('Waiter deleted', 'success')
              if (selectedOutlet !== undefined && selectedOutlet !== '') {
                if (fetchWaitersData.data.length - 1 >= 1) {
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: page,
                    limit: limit
                  }
                  fetchWaiters(payload)
                } else {
                  setPage(1)
                  let payload = {
                    outlet_id: selectedOutlet,
                    pageNumber: 1,
                    limit: limit
                  }
                  fetchWaiters(payload)
                }
              }
              setDeleteConfirmationVisibility(false)
            }
          })
        }}
      />
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}

export default Waiter
